<template>
  <session class="mobile-page-contactus">
    <Header />
    <div class="contactus-block">
      <div class="contactus-block-t">
        <div class="bgimg" />
        <div class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ blockTitle }}</div>
        <div class="desc" v-html="Utils.presetHtmlText(blockDesc)" />
        <div class="contactus-block-tr">
          <div class="form-block">
            <div class="form-block-title"><span>{{LOCAL('contactus_inquiryType')}}</span></div>
            <div class="form-items-wrap">
              <FormItemSelect
                :label="LOCAL('contactus_inquiryType1')" 
                :options="consultOptions" 
                :value="consultValue" 
                @change="item => {consultValue = item[0].value,consultError = false}"
                :error="consultError"
                :vertical="true"
              />
              <FormItemTextarea 
                :label="LOCAL('contactus_inquiryType2')" 
                :value="consultContentValue" 
                @change="value => {consultContentValue = value,consultContentError = false}" 
                :error="consultContentError"
              />
            </div>
          </div>
          <div class="form-block">
            <div class="form-block-title"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('contactus_contactInformation')}}</span></div>
            <FormItemInput
              :style="{ flex: 1, marginBottom: contactNameError ? '28px' : '12px' }" 
              :label="LOCAL('contactus_contactInformation1')" 
              style="flex: 1;" 
              @change="value => {contactNameValue = value, contactNameError = false}"
              :error="contactNameError"
              isRequired
            />
            <FormItemInput 
              :style="{ flex: 1, marginBottom: '12px' }" 
              :label="LOCAL('contactus_contactInformation2')" 
              style="flex: 1;" 
              @change="value => contactFamilyNameValue = value"
            />
            <FormItemCheckbox 
              style="margin-bottom: 12px;" 
              :value="sexValue" 
              :options="sexOptions"
              @change="value => sexValue = value"
            />

            <FormItemSelect 
              :style="{ flex: 1, zIndex: 99, marginBottom: countryError ? '28px' : '12px' }" 
              :label="LOCAL('contactus_contactInformation5')" 
              :options="countryOptions" 
              :value="countryValue" 
              @change="item => {getCountryCode(item),countryError = false}"
              :error="countryError"
            />
            <FormItemInput 
              :style="{ flex: 1, marginBottom: '12px' }"  
              :label="LOCAL('contactus_contactInformation6')"
              @change="value => cityValue = value"
            />
            <!-- <FormItemSelect 
              :style="{ flex: 1, marginBottom: cityError ? '28px' : '12px' }" 
              :label="LOCAL('contactus_contactInformation6')" 
              :options="cityOptions" 
              :value="cityValue" 
              @change="item => cityValue = item.value"
              :error="cityError"
            /> -->
            <FormItemInput 
              :style="{ flex: 1, marginBottom: '12px' }" 
              :label="LOCAL('contactus_contactInformation7')"
              :dfvalue="countryCodeValue" 
              @change="value => getCountryInput(value)"
              :disabled="otherCountry"
              :placeholder="otherCountry ? '' : LOCAL('placeholder_common') "
              :optionWrapStyle="{ maxHeight: '121px' }"
            />
            <FormItemInput 
              :style="{ flex: 1, marginBottom: mobileError ? '28px' : '12px' }"  
              :label="LOCAL('contactus_contactInformation8')"
              @change="value => {mobileValue = value,mobileError = false}"
              :error="mobileError"
              isRequired
            />

            <!-- <FormItemCheckbox 
              style="margin-top: 30px;"
              :value="protocolValue" 
              :options="[
                { value: 1, label: LOCAL('contactus_submit_protocol'), style: { alignItems: 'flex-start' } },
              ]"
              @change="value => protocolValue = value"
            /> -->
            <div v-html="LOCAL('contactus_submit_protocol')" class="term_policy_agree"></div>
          </div>
        </div>
      </div>
        <div class="submit-btn-wrap">
          <div class="submit-btn" @click="submitHandle"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('contactus_submit')}}</span></div>
        </div>

      <div class="block-header"><span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ blockPlacesTitle }}</span></div>
      <div class="contactus-block-b">
        <div class="item" v-for="(item, index) in placesList" :key="index">
          <span class="name" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.name }}</span>
          <span class="address" v-html="Utils.presetHtmlText(item?.address)" />
          <div class="contact-info">
            <div class="contact"><Icon name="phone" size="12" /><span>{{ item?.contact }}</span></div>
            <div class="email"><Icon name="mail" size="12" /><span>{{ item?.email }}</span></div>
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <div class="contactus-submit-result-wrap" v-if="submitResultFlag">
      <div class="contactus-submit-result-container">
        <Icon name="success" size="60" />
        <div class="result-content">
          <span :class="{ ffen: getLocalLangCode() != 'zh' }" v-html="Utils.presetHtmlText(LOCAL('result_feedback'))" />
        </div>
        <div class="result-btns">
          <div class="item" @click="Utils.toTargetPage('/')">{{LOCAL('backtohome')}}</div>
          <div class="item primary" @click="confirmSubmit">{{LOCAL('iknowle')}}</div>
        </div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Icon from '@/components/icon/index.vue';
  import Header from '@/mobile/components/header/index.vue';
  import Footer from '@/mobile/components/footer/index.vue';
  import FormItemSelect from '@/mobile/components/formitemselect/index.vue';
  import FormItemTextarea from '@/mobile/components/formitemtextarea/index.vue';
  import FormItemInput from '@/mobile/components/formiteminput/index.vue';
  import FormItemCheckbox from '@/mobile/components/formitemcheckbox/index.vue';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  const blockTitle = ref('');
  const blockDesc = ref('');
  const blockPlacesTitle = ref('');
  const placesList = ref([]);
  const init = () => {
    blockTitle.value = LOCAL('contactus_contactUs');
    blockDesc.value = LOCAL('contactus_contactUs_desc');
    blockPlacesTitle.value = LOCAL('contactus_offices');
    placesList.value = LOCAL('contactus_offices_list')
  }
  onMounted(() => {
    init()
  })

  // 咨询类型
  const consultOptions = ref([
    { value: LOCAL('contactus_inquiryType1Options')[0], label: LOCAL('contactus_inquiryType1Options')[0] },
    { value: LOCAL('contactus_inquiryType1Options')[1], label: LOCAL('contactus_inquiryType1Options')[1] },
    { value: LOCAL('contactus_inquiryType1Options')[2], label: LOCAL('contactus_inquiryType1Options')[2] },
    { value: LOCAL('contactus_inquiryType1Options')[3], label: LOCAL('contactus_inquiryType1Options')[3] },
    { value: LOCAL('contactus_inquiryType1Options')[4], label: LOCAL('contactus_inquiryType1Options')[4] },
    { value: LOCAL('contactus_inquiryType1Options')[5], label: LOCAL('contactus_inquiryType1Options')[5] },
    { value: LOCAL('contactus_inquiryType1Options')[6], label: LOCAL('contactus_inquiryType1Options')[6] },
    { value: LOCAL('contactus_inquiryType1Options')[7], label: LOCAL('contactus_inquiryType1Options')[7] }
  ]);
  const consultValue = ref(null);
  const consultError = ref(false);

  // 咨询问题
  const consultContentValue = ref('');
  const consultContentError = ref(false);

  // 姓名
  const contactFamilyNameValue = ref('');
  const contactNameValue = ref('');
  const contactFamilyNameError = ref(false);
  const contactNameError = ref(false);

  // 性别
  const sexOptions = ref([
    { label: LOCAL('contactus_contactInformation4'), value: LOCAL('contactus_contactInformation4') },
    { label: LOCAL('contactus_contactInformation3'), value: LOCAL('contactus_contactInformation3') },
  ]);
  const sexValue = ref(null);

  // 国家
  const countryOptions = ref(LOCAL('contactus_countryOptions').map(item => ({ label: item, value: item })));
  const countryValue = ref(null);
  const countryError = ref(false);

  // 城市
  // const cityOptions = ref([
  //   { value: '上海', label: '上海' },
  //   { value: '北京', label: '北京' },
  //   { value: '深圳', label: '深圳' }
  // ]);
  const cityValue = ref(null);
  const cityError = ref(false);

  // 国家区号
  const countryCodeOptions = ref(LOCAL('contactus_countryCodeOptions').map(item => ({ label: item, value: item })));
  const countryCodeValue = ref(null);


  const otherCountry = ref(true)
  const getCountryCode = (item) => {
    countryValue.value = item[0].value
    if(item[1] + 1 === item[2]){
      otherCountry.value = false
      countryCodeValue.value = ''
    } else {
      otherCountry.value = true
      countryCodeValue.value = countryCodeOptions.value[item[1]*1].value
    }
  }

  const getCountryInput = (item) => {
    if(typeof(item)=== 'string'){
      countryCodeValue.value = item
    } else {
      countryCodeValue.value = item.target.value
    }
  }


  // 手机号
  const mobileValue = ref('');
  const mobileError = ref(false);

  // 用户协议
  const protocolValue = ref(null);

  // 提交
  const submitResultFlag = ref(false);
  const submitHandle = () => {
    const submitObj = {
      consult: consultValue.value,
      country: countryValue.value,
      city: cityValue.value,
      sex: sexValue.value,
      countryCode: countryCodeValue.value,
      consultContent: consultContentValue.value,
      contactName: contactNameValue.value,
      contactFamilyName: contactFamilyNameValue.value,
      mobile: mobileValue.value,
    }

    consultError.value = !submitObj.consult;
    consultContentError.value = !submitObj.consultContent;
    contactNameError.value = !submitObj.contactName;
    //contactFamilyNameError.value = !submitObj.contactFamilyName;
    countryError.value = !submitObj.country;
    //cityError.value = !submitObj.city;
    mobileError.value = !submitObj.mobile;

    if(consultError.value || consultContentError.value || contactNameError.value || countryError.value || mobileError.value) {
      return;
    }

    console.log('submitObj', submitObj);
    submitResultFlag.value = true;
  }

  const confirmSubmit = () => {
    window.location.reload();
  }

</script>

<style scoped lang="less">
  @import "index.less";
</style>
